import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { GeoPoint } from '@core/models/geo.state';
import { StoreState, StoreWithDistanceState } from '@core/models/store.state';
import { MockDataService } from '@core/services/mock-data.service';
import { haversineMiles } from '@core/utils/geo';

import { mockResponse } from '../mock-response';
import { StoreRepository } from './store.repository';
import { seedStores } from './store.seed';

const COLLECTION = 'stores';

@Injectable()
export class StoreMockRepository implements StoreRepository {
  private readonly stores = inject(MockDataService).collection<StoreState>(COLLECTION, seedStores);

  getById(id: number): Observable<StoreState | null> {
    return mockResponse(this.stores.get(id) ?? null);
  }

  listByTenant(tenantId: number): Observable<StoreState[]> {
    return mockResponse(this.stores.list().filter(s => s.tenantId === tenantId));
  }

  nearby(origin: GeoPoint, radiusMi: number): Observable<StoreWithDistanceState[]> {
    const withDistance = this.stores
      .list()
      .filter(s => s.pickupEnabled)
      .map(s => ({ ...s, distanceMi: haversineMiles(origin, s) }))
      .filter(s => s.distanceMi <= radiusMi)
      .sort((a, b) => a.distanceMi - b.distanceMi);
    return mockResponse(withDistance);
  }
}
